import { useEffect, useState } from "react";

export const DetectarTela = () => {
  const [menuMobile, setMenuMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 900) {
        setMenuMobile(true);
      } else {
        setMenuMobile(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return menuMobile;
};
